import React, { useState } from 'react';

function OutfitRecommendations({ bodyShape, skinTone, activeOccasion }) {
  const AMAZON_ID = 'vikash071109-21';
  
  const [activeCategory, setActiveCategory] = useState('outfits');

  const outfitProducts = {
    gym: [
      { name: "Nike Pro Compression Shirt", price: "$35", link: `https://www.amazon.com/s?k=nike+pro+compression&tag=${AMAZON_ID}`, emoji: "🎽" },
      { name: "Lululemon Align Leggings", price: "$98", link: `https://www.amazon.com/s?k=lululemon+align&tag=${AMAZON_ID}`, emoji: "🧘" },
      { name: "Under Armour HeatGear", price: "$25", link: `https://www.amazon.com/s?k=under+armour+heatgear&tag=${AMAZON_ID}`, emoji: "💪" },
      { name: "Adidas Running Shorts", price: "$30", link: `https://www.amazon.com/s?k=adidas+running+shorts&tag=${AMAZON_ID}`, emoji: "🏃" }
    ],
    party: [
      { name: "Calvin Klein Slim Blazer", price: "$150", link: `https://www.amazon.com/s?k=calvin+klein+blazer&tag=${AMAZON_ID}`, emoji: "🕴️" },
      { name: "Tommy Hilfiger Cocktail Dress", price: "$120", link: `https://www.amazon.com/s?k=tommy+hilfiger+dress&tag=${AMAZON_ID}`, emoji: "👗" },
      { name: "Levi's Leather Jacket", price: "$180", link: `https://www.amazon.com/s?k=levis+leather+jacket&tag=${AMAZON_ID}`, emoji: "🧥" },
      { name: "Steve Madden Heels", price: "$90", link: `https://www.amazon.com/s?k=steve+madden+heels&tag=${AMAZON_ID}`, emoji: "👠" }
    ],
    casual: [
      { name: "Uniqlo Premium T-Shirt", price: "$15", link: `https://www.amazon.com/s?k=uniqlo+t+shirt&tag=${AMAZON_ID}`, emoji: "👕" },
      { name: "Levi's 501 Original Jeans", price: "$60", link: `https://www.amazon.com/s?k=levis+501&tag=${AMAZON_ID}`, emoji: "👖" },
      { name: "Ralph Lauren Polo Shirt", price: "$85", link: `https://www.amazon.com/s?k=ralph+lauren+polo&tag=${AMAZON_ID}`, emoji: "🏌️" },
      { name: "Dockers Classic Chinos", price: "$50", link: `https://www.amazon.com/s?k=dockers+chinos&tag=${AMAZON_ID}`, emoji: "👔" }
    ],
    formal: [
      { name: "Hugo Boss Wool Suit", price: "$400", link: `https://www.amazon.com/s?k=hugo+boss+suit&tag=${AMAZON_ID}`, emoji: "🤵" },
      { name: "Brooks Brothers Dress Shirt", price: "$80", link: `https://www.amazon.com/s?k=brooks+brothers+shirt&tag=${AMAZON_ID}`, emoji: "👔" },
      { name: "Anne Klein Pencil Skirt", price: "$70", link: `https://www.amazon.com/s?k=anne+klein+pencil+skirt&tag=${AMAZON_ID}`, emoji: "👚" },
      { name: "Cole Haan Dress Shoes", price: "$150", link: `https://www.amazon.com/s?k=cole+haan+dress+shoes&tag=${AMAZON_ID}`, emoji: "👞" }
    ],
    beach: [
      { name: "Tommy Bahama Linen Shirt", price: "$110", link: `https://www.amazon.com/s?k=tommy+bahama+linen&tag=${AMAZON_ID}`, emoji: "🌴" },
      { name: "Havaianas Flip Flops", price: "$25", link: `https://www.amazon.com/s?k=havaianas&tag=${AMAZON_ID}`, emoji: "🩴" },
      { name: "Ray-Ban Sunglasses", price: "$150", link: `https://www.amazon.com/s?k=ray+ban+sunglasses&tag=${AMAZON_ID}`, emoji: "🕶️" },
      { name: "Speedo Swim Trunks", price: "$40", link: `https://www.amazon.com/s?k=speedo+swim+trunks&tag=${AMAZON_ID}`, emoji: "🏊" }
    ]
  };

  const browseAllLinks = [
    { name: "Browse All Men's Fashion", price: "See Deals", link: `https://www.amazon.com/s?k=mens+fashion&tag=${AMAZON_ID}`, emoji: "👔" },
    { name: "Browse All Women's Fashion", price: "See Deals", link: `https://www.amazon.com/s?k=womens+fashion&tag=${AMAZON_ID}`, emoji: "👗" },
    { name: "Amazon Fashion Best Sellers", price: "Top Picks", link: `https://www.amazon.com/Best-Sellers/zgbs/fashion?tag=${AMAZON_ID}`, emoji: "🛍️" }
  ];

  const faceProducts = [
    { name: "Moroccanoil Treatment", category: "Hair Care", price: "$44", link: `https://www.amazon.com/dp/B001AO0WCG?tag=${AMAZON_ID}`, emoji: "🧴" },
    { name: "Dyson Airwrap", category: "Styling Tools", price: "$599", link: `https://www.amazon.com/dp/B0B3CJSXXW?tag=${AMAZON_ID}`, emoji: "💨" },
    { name: "Oribe Dry Texturizing Spray", category: "Styling", price: "$49", link: `https://www.amazon.com/dp/B003NXM9QC?tag=${AMAZON_ID}`, emoji: "✨" },
    { name: "Ghd Platinum+ Styler", category: "Hot Tools", price: "$279", link: `https://www.amazon.com/dp/B07CM53DBZ?tag=${AMAZON_ID}`, emoji: "🔥" },
    { name: "Madison Reed Root Touch Up", category: "Hair Color", price: "$30", link: `https://www.amazon.com/s?k=Madison+Reed&tag=${AMAZON_ID}`, emoji: "🎨" },
    { name: "Biolage Color Last Shampoo", category: "Color Care", price: "$20", link: `https://www.amazon.com/dp/B00ILB9E6C?tag=${AMAZON_ID}`, emoji: "🧼" }
  ];

  const currentOutfits = outfitProducts[activeOccasion] || outfitProducts.casual;

  return (
    <div className="product-recommendations">
      <h3>🛒 Shop Recommended Products</h3>
      
      <div className="product-categories">
        <button 
          className={`category-btn ${activeCategory === 'outfits' ? 'active' : ''}`}
          onClick={() => setActiveCategory('outfits')}
        >
          👔 Outfits & Clothing
        </button>
        <button 
          className={`category-btn ${activeCategory === 'beauty' ? 'active' : ''}`}
          onClick={() => setActiveCategory('beauty')}
        >
          💇 Face & Hair Care
        </button>
        <button 
          className={`category-btn ${activeCategory === 'browse' ? 'active' : ''}`}
          onClick={() => setActiveCategory('browse')}
        >
          🛍️ Browse All
        </button>
      </div>

      {activeCategory === 'outfits' && (
        <>
          <p className="affiliate-note">Perfect for {activeOccasion} • Handpicked for {bodyShape} shape</p>
          <div className="product-grid">
            {currentOutfits.map((product, idx) => (
              <a 
                key={idx} 
                href={product.link} 
                className="product-card"
                target="_blank"
                rel="noopener noreferrer sponsored"
              >
                <div className="product-icon">{product.emoji}</div>
                <div className="product-info">
                  <div className="product-name">{product.name}</div>
                  <div className="product-price">{product.price}</div>
                </div>
                <div className="product-cta">Shop on Amazon →</div>
              </a>
            ))}
          </div>
        </>
      )}

      {activeCategory === 'beauty' && (
        <>
          <p className="affiliate-note">Recommended for {skinTone} undertone • Hair & face care</p>
          <div className="product-grid">
            {faceProducts.map((product, idx) => (
              <a 
                key={idx} 
                href={product.link} 
                className="product-card"
                target="_blank"
                rel="noopener noreferrer sponsored"
              >
                <div className="product-icon">{product.emoji}</div>
                <div className="product-info">
                  <div className="product-category">{product.category}</div>
                  <div className="product-name">{product.name}</div>
                  <div className="product-price">{product.price}</div>
                </div>
                <div className="product-cta">Shop on Amazon →</div>
              </a>
            ))}
          </div>
        </>
      )}

      {activeCategory === 'browse' && (
        <>
          <p className="affiliate-note">Explore Amazon's full catalog • You earn on anything they buy!</p>
          <div className="product-grid">
            {browseAllLinks.map((product, idx) => (
              <a 
                key={idx} 
                href={product.link} 
                className="product-card"
                target="_blank"
                rel="noopener noreferrer sponsored"
              >
                <div className="product-icon">{product.emoji}</div>
                <div className="product-info">
                  <div className="product-name">{product.name}</div>
                  <div className="product-price">{product.price}</div>
                </div>
                <div className="product-cta">Browse on Amazon →</div>
              </a>
            ))}
          </div>
        </>
      )}

      <div className="salon-finder">
        <h4>Need Professional Help?</h4>
        <p>Find stylists and personal shoppers near you</p>
        <a 
          href="https://www.styleseat.com" 
          className="btn-salon" 
          target="_blank" 
          rel="noopener noreferrer sponsored"
        >
          Find Professionals
        </a>
      </div>
    </div>
  );
}

export default OutfitRecommendations;